import LabeledPhoneInput from "components/labeledInput/LabeledPhoneInput";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledPhoneInput);
